// extracted by mini-css-extract-plugin
export default {"container":"login_container__6m7Pp","wrapper":"login_wrapper__WOQG3","card":"login_card__FCKzU","footerTag":"login_footerTag__VdFH9"};